import { twMerge } from 'tailwind-merge';
import { Section } from '@/ui/components';
import type { SectionProps } from '@/ui/components/Section/Section';
import { Platforms } from '../../constants';
import { usePlatform } from '../../hooks';

export default function PlatformSection(props: SectionProps) {
  const { className, ...rest } = props;

  const platform = usePlatform();

  if (platform === Platforms.MOBILE) {
    return <Section {...props} />;
  }

  return <Section className={twMerge('border-none rounded-none', className)} {...rest} />;
}
